export default __webpack_public_path__ + "static/media/someta_graph.768b42b4.png";